// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1pLrs","approved":"Status_approved__3--ZH","rejected":"Status_rejected__2cYAs","expired":"Status_expired__2DTo0","label":"Status_label__3EE_8"};